// extracted by css-extract-rspack-plugin
export default {"component":"Component-module__component___KvHha","footer":"Component-module__footer___y4qD1"};